import { defineMessages } from 'react-intl';

import ImageListEdit from './ImageListEdit';
import ImageListView from './ImageListView';
import { imageListSchema } from './schema';

import iconSVG from './icons/image-list.svg';

defineMessages({
  imageList: {
    id: 'Image list',
    defaultMessage: 'Image list',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.imagelistBlock = {
    id: 'imagelistBlock',
    title: 'Image list',
    group: 'listing',
    icon: iconSVG,
    view: ImageListView,
    edit: ImageListEdit,
    blockSchema: imageListSchema,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
